<template>
  <div class="mt-3 p-2">
    <b-container fluid class="mb-2">
      <!-- Heading section -->
      <b-row class="mb-2">
        <b-col md="6">
          <h5 class="text-uppercase heading">Work Orders</h5>
          <p>List of the Work Orders in the Organization</p>
        </b-col>
        <b-col md="6" class="text-right">
          <workOrderCreate
            @create="fetchData"
            :activitiesType="activitiesType"
          ></workOrderCreate>
        </b-col>
      </b-row>
      <!-- project, zone and plot level filter -->
      <b-row class="mb-2">
        <b-col md="4">
          <b-form-group
            id="input-group-1"
            label=""
            label-for="input-2"
          >
            <select
              name=""
              id=""
              class="form-control"
              v-model="filters.project_id"
              @change="projectChange"
            >
              <option value="">Select Project</option>
              <option
                :value="project._id"
                v-for="(project, index) in projects"
                :key="index"
              >
                {{ project.name }}
              </option>
            </select>
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group
            id="input-group-2"
            label=""
            label-for="input-2"
          >
            <select
              name=""
              id=""
              class="form-control"
              v-model="filters.zone_id"
              @change="zoneChange"
              :disabled="!filters.project_id"
            >
              <option value="">Select Zone</option>
              <option
                :value="zone._id"
                v-for="(zone, index) in zones"
                :key="index"
              >
                {{ zone.code }}
              </option>
            </select>
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group
            id="input-group-2"
            label=""
            label-for="input-2"
          >
            <select
              name=""
              id=""
              class="form-control"
              v-model="plot_id"
              :disabled="!filters.zone_id"
            >
              <option value="">Select Plot</option>
              <option
                :value="plot._plot_id._id"
                v-for="(plot, index) in plots"
                :key="index"
              >
                {{ plot._plot_id.code }}
              </option>
            </select>
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-form-group
            id="input-group-2"
            label=""
            label-for="input-2"
          >
            <select
              name=""
              id=""
              class="form-control"
              v-model="filters.activity_type"
            >
              <option value="">Select Activity Type</option>
              <option
                :value="activity._id"
                v-for="(activity, i) in activitiesType"
                :key="i"
              >
                {{ activity.name }}
              </option>
            </select>
          </b-form-group>
        </b-col>

          <b-col md="3">
  <b-form-group id="input-group-2" label="" label-for="input-2">
    <select
      name=""
      id=""
      class="form-control"
      v-model="filters.status"
    >
      <option :value="null">Select Status</option>
      <option :value="true">Approved</option>
      <option :value="false">Pending</option>
      
    </select>
  </b-form-group>
</b-col>
        <!-- <b-col md="2">
          <b-form-group id="input-group-1" label="" label-for="input-2">
            <select
              name=""
              id=""
              class="form-control"
              v-model="filters.created_by"

            >
              <option value="">Select Created By</option>
              <option
                :value="user._id"
                v-for="(user, index) in users"
                :key="index"
              >
                {{ user.name }}
              </option>
            </select>
          </b-form-group>
        </b-col> -->
      </b-row>
      <b-row class="mb-2">
        <b-col md="2">
          <b-button variant="success" @click="fetchData" block>
            Search
          </b-button>
        </b-col>
      </b-row>
      <div class="row mb-2">
        <div class="col-md-6">
          <button
            type="button"
            class="btn btn-primary"
            :disabled="selectedWorkOrder.length == 0"
            @click="approveWorkOrder"
          >
            <span class="badge badge-secondary">
              {{ selectedWorkOrder.length }}
            </span>
            Selected For Approval
          </button>
        </div>
      </div>

      <b-table
        class="dataTable rounded-left"
        :items="items"
        :fields="fields"
        head-variant="none"
        table-variant="none"
        :busy="isBusy"
      >
        <template #cell(#)="data">
          <input
            type="checkbox"
            :name="'work_order' + data.item._id"
            :id="'work_order' + data.item._id"
            v-model="selectedWorkOrder"
            :disabled="data.item.status == 1 ? true : false"
            :value="data.item._id"
          />
        </template>

        <template #cell(image_url)="row">
          <img
            v-if="row.item.image_url"
            :src="row.item.image_url[0]"
            class="rounded"
            width="50px"
            height="50px"
          />
        </template>

        <template #cell(current_status)="row">
          <span
            v-if="row.item.status == 0"
            class="badge badge-warning"
            >APPROVAL PENDING</span
          >
          <span
            v-if="row.item.status == 1"
            class="badge badge-success"
            >APPROVED</span
          >
        </template>
        <template #cell(start_date)="row">
          {{ row.item.start_date | moment("DD-MM-YYYY") }}
        </template>
        <template #cell(end_date)="row">
          {{ row.item.end_date | moment("DD-MM-YYYY") }}
        </template>
        <template #cell(created_ts)="row">
          {{ row.item.created_ts | moment("DD-MM-YYYY") }}
        </template>
        <template #cell(progress_status)="row">
          <span v-if="row.item.progress_status == 1">Pending</span>
          <span v-else-if="row.item.progress_status == 2"
            >In Progress</span
          >
          <span v-else-if="row.item.progress_status == 3"
            >Completed</span
          >
        </template>

        <template #cell(actions)="row">
          <b-dropdown
            size="sm"
            id="dropdown-1"
            text="Actions"
            variant="primary"
          >
            <b-dropdown-item>
              <router-link
                :to="'/work-orders/' + row.item._id"
                style="text-decoration: none; color: #000"
              >
                View
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item v-if="!row.item.status">
              <router-link
                :to="'/work-orders/' + row.item._id + '/edit'"
                style="text-decoration: none; color: #000"
                >Edit
              </router-link>
            </b-dropdown-item>
            <b-dropdown-item v-if="!row.item.status">
              <div
                :value="row.item._id"
                @click="approve(row.item._id)"
              >
                Approve
              </div>
            </b-dropdown-item>
            <b-dropdown-item v-if="!row.item.status">
              <div @click="deleteActivity(row.item._id)">Delete</div>
            </b-dropdown-item>
          </b-dropdown>
        </template>

        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
      </b-table>
      <div class="d-flex justify-content-center mt-4">
        <b-pagination
          v-if="datas.length>0"
          size="md"
          :per-page="perPage"
          :total-rows="totalRows"
          v-model="currentPage"
          @input="fetchData"
          first-number
          last-number
        ></b-pagination>
      </div>
    </b-container>
  </div>
</template>

<script>
import workOrderCreate from "@/components/workorder/create";
import moment from "moment";
export default {
  components: {
    workOrderCreate,
  },
  data() {
    return {
      selectedWorkOrder: [],
      sortDesc: false,
      filter: null,
      totalRows: 0,

      isBusy: false,
      items: [],
      downloadItems: [],
      fields: [
        "#",
        {
          key: "image_url",
          label: "Image",
        },

        {
          key: "code",
          label: "Code",
          sortable: true,
        },
        {
          key: "_activity_type.name",
          label: "Type",
          sortable: true,
        },
        {
          key: "progress",
          label: "Progress",
          sortable: true,
        },
        {
          key: "progress",
          label: "Activity Progress",
          sortable: true,
        },
        {
          key: "start_date",
          label: "Start Date",
          sortable: true,
        },
        {
          key: "end_date",
          label: "End Date",
          sortable: true,
        },
        {
          key: "current_status",
          label: "Status",
          sortable: true,
        },
        {
          key: "created_ts",
          label: "Created Date",
          sortable: true,
        },
        {
          key: "_created_by.name",
          label: "Created By",
          sortable: true,
        },
        "actions",
      ],
      datas: [],
      activitiesType: "",
      project_id: "",
      zone_id: "",
      plot_id: "",
      users: [],
      zones: [],
      projects: [],
      plots: [],
      filters: {
        created_by: "",
        activity_type: "",
        project_id: "",
        zone_id: "",
        plot_id: "",
        status:null
      },
      perPage: 15,
      currentPage: 1,
    };
  },

  mounted() {
    this.currentPage = Number(this.$route.query.page) || 1;
    this.getGroundStaffUser();
    this.fetchData();
    this.getActivityType();
    this.getProjects();
  },
  computed: {
    rows() {
      return this.items.length;
    },
  },


  methods: {
    getProjects() {
      window.axios.get("project").then((resp) => {
        this.projects = resp.data.data;
      });
    },
    filtered(filteredItems) {
      this.downloadItems = filteredItems;
    },

    downloadCSV() {
      let csv =
        "\ufeff" +
        "DESCRIPTION,ACTIVITY CODE, ACTIVITY TYPE, ACTIVITY STATUS, ACTIVITY PROGRESS, START DATE, END DATE, CREATED DATE\n";
      this.downloadItems.forEach((el) => {
        let activityStatus = "";
        if (el["progress_status"] === 1) {
          activityStatus = "Pending";
        } else if (el["progress_status"] === 2) {
          activityStatus = "In Progress";
        } else {
          activityStatus = "Completed";
        }

        var line =
          el["description"] +
          "," +
          el["code"] +
          "," +
          el["_activityTypeID"].name +
          "," +
          activityStatus +
          "," +
          el["progress"] +
          "," +
          `${moment(el["start_date"]).format("DD-MM-YYYY")}` +
          "," +
          `${moment(el["end_date"]).format("DD-MM-YYYY")}` +
          "," +
          `${moment(el["created_ts"]).format("DD-MM-YYYY")}` +
          "\n";
        csv += line;
      });
      var blob = new Blob([csv], { type: "csv/plain" });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "Activities.csv";
      link.click();
    },

    getGroundStaffUser() {
      window.axios.get("/ground-staff-user").then((resp) => {
        this.users = resp.data.data;
      });
    },
    getActivityType() {
      window.axios.get("activity-type").then((resp) => {
        this.activitiesType = resp.data.data;
      });
    },
    deleteActivity(id) {
      let prompt = confirm(
        "Are you sure want to delete the work order ? "
      );
      if (prompt) {
        window.axios.delete("work-orders/" + id).then(() => {
          this.fetchData();
        });
      }
    },

    approve(id) {
      let resp = confirm(
        "Are you sure want to approve the work order?"
      );

      if (resp) {
        this.isBusy = true;
        window.axios
          .post("/work-orders/" + id + "/approve")
          .then((resp) => {
            if (resp.data.success) {
              alert("Work Order is Approved");
              window.location.reload();
              this.isBusy = false;
            } else {
              this.isBusy = false;
            }
          })
          .catch((error) => {
            console.log(error);
            this.isBusy = false;
          });
      } else {
        alert("rejected");
      }
    },
    fetchData() {
      this.isBusy = true;
        this.$router.replace({ 
          query: { ...this.$route.query, page: this.currentPage }
        });
      window.axios
        .get("/work-orders", {
          params: {
            created_by: this.filters.created_by,
            activity_type: this.filters.activity_type,
            project_id: this.filters.project_id,
            zone_id: this.filters.zone_id,
            plot_id: this.filters.plot_id,
            status:this.filters.status,
            perPage: this.perPage,
            currentPage: this.currentPage,
          },
        })
        .then((resp) => {
         
          
          if (resp.data.success) {
           Object.assign(this, {
      isBusy: false,
      datas: resp.data.data,
      items: resp.data.data,
      downloadItems: resp.data.data,
      totalRows: resp.data.totalRows,
     
    });
          }
          setTimeout(() => (this.success = false), 3000);
        });
    },


    projectChange() {
      (this.zones = []), (this.plots = []);
      this.zone_id = "";
      this.plot_id = "";
      this.selectedProject = this.projects.filter((number) => {
        return number._id == this.filters.project_id
          ? number.name
          : false;
      });
      window.axios
        .get("/project-zones/" + this.filters.project_id)
        .then((resp) => {
          this.zones = resp.data.data;
        });
    },
    
    async approveWorkOrder() {
      if (this.selectedWorkOrder.length > 0) {
        let resp = confirm(
          "Are you sure want to approve the work order?"
        );
        for (let i = 0; i < this.selectedWorkOrder.length; i++) {
          let currentWorkOrder = this.selectedWorkOrder[i];

          if (resp) {
            this.isBusy = true;
            await window.axios.post(
              "/work-orders/" + currentWorkOrder + "/approve"
            );
          } else {
            alert("rejected");
          }
        }
        alert("Work Order is Approved");
        window.location.reload();
        this.isBusy = false;
      }
    },
    zoneChange() {
      this.selectedZone = this.zones.filter((number) => {
        return number._id == this.filters.zone_id
          ? number.code
          : false;
      });

      window.axios
        .get("/all-plots-assigned/" + this.filters.zone_id)
        .then((resp) => {
          this.plots = resp.data.data;
        });
    },
  },
};
</script>

<style scoped>
.heading {
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  font-size: 20px;
  line-height: 30px;
  letter-spacing: 3.5%;
  margin-top: 5px;
  margin-bottom: 5px;
  color: #454545;
}
 .dataTable thead {
  background-color: #dcffd9;
  height: 64px;
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 3.5%;
  font-family: "Poppins", sans-serif;
  padding-top: 14px;
  padding-bottom: 14px;
  color: #303030;
}
.dataTable {
  text-align: center;
  margin-bottom: 21.5px;
  margin-left: 2px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
}
.dataTable tr td {
  font-family: "Poppins", sans-serif;
  font-size: 17px;
  letter-spacing: 3.5%;
  line-height: 25.5px;
  font-weight: 400;
  padding-top: 12px;
  padding-bottom: 12px;
}
</style>
